"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberedStep = void 0;
const react_1 = __importDefault(require("react"));
const ui_library_1 = require("@hum/ui-library");
function NumberedStep({ testId, number, children }) {
    return (react_1.default.createElement("div", { className: "flex items-start mb-6 last:mb-0", "data-testid": testId },
        react_1.default.createElement(ui_library_1.Text, { type: ui_library_1.TextType.BODY_MICO, className: "flex items-center justify-center p-4 w-8 h-8 rounded-full bg-primary-500 text-white mr-4 border border-borderColor" }, number),
        children));
}
exports.NumberedStep = NumberedStep;
//# sourceMappingURL=NumberedStep.js.map